import React from 'react';

const PushPullDevices = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 86.037 54.693"
			className={className}
		>
			<g fill="currentColor">
				<path d="M7.984 34.128a.911.911 0 1 0 .647.267.91.91 0 0 0-.647-.267Z" />
				<path d="M27.259 34.128a.911.911 0 1 0 .647.267.909.909 0 0 0-.647-.267Z" />
				<path d="M7.983 19.056a.911.911 0 1 0 .642.267.916.916 0 0 0-.642-.267Z" />
				<path d="M27.259 19.056a.911.911 0 1 0 .642.267.916.916 0 0 0-.642-.267Z" />
				<path d="m39.9 51.757 5.083 2.936V52.37H71.85v2.323l5.083-2.936-5.083-2.935v2.321H44.983v-2.321Z" />
				<path d="M44.983 2.323V0L39.9 2.936l5.083 2.935V3.55H71.85v2.321l5.083-2.935L71.85 0v2.323Z" />
				<path d="M65.503 19.418v-7.145H51.327v7.145H35.243v-7.144H0V42.42h35.241v-7.144h16.084v7.144H65.5v-7.144h20.536V19.418H65.501Zm14.187 3.065h3.28v6.152Zm3.1 9.726h-9.14l-5.18-9.726h9.14l5.189 9.726Zm-31.468-1.513-4.381-8.214h4.381Zm-1.279 1.513h-9.142l-5.187-9.726h9.142ZM32.17 39.354H3.07V15.341h29.1V39.354Zm3.067-13.853 3.579 6.71H35.24Zm27.195 13.853h-8.044V15.34h8.044Zm3.067-16.869h.877l5.194 9.726h-6.064Z" />
			</g>
		</svg>
	);
};

export default PushPullDevices;
